import React from 'react';
import Modal from '../../../../Components/Modal/Modal';
import PatientsGroupsCreateByImport from './PatientsGroupsCreateByImport';
import { Size } from '../../../../Enums/Size.enum';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	onSuccess: () => void;
}

const PatientsGroupsCreateByImportModal: React.FC<Props> = ({
	isOpen,
	onClose,
	onSuccess,
}) => {
	return (
		<Modal opened={isOpen} onClose={onClose} size={Size.LG}>
			<Modal.Header title='component.groupMsgs.createGroupByImport' />
			<Modal.Content>
				<PatientsGroupsCreateByImport onSuccess={onSuccess} />
			</Modal.Content>
		</Modal>
	);
};

export default PatientsGroupsCreateByImportModal;
